
import React from 'react';
import ReactDOM from 'react-dom';
import authStorage from './utils/authStorage';
import App from './components/App';

ReactDOM.render(<App authData={authStorage.get()} />, document.getElementById('root'));
